import React, { useRef, useState } from "react";
import Papa from 'papaparse';
import Button from '@material-ui/core/Button';
import "tabulator-tables/dist/css/tabulator.min.css";
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import DataProvider from '../DataProvider.js';

const fields = ['fName', 'lName', 'phone', 'email'];

const styles = {
    btn: {
        color: "red",
    }
};

const CsvParseButton = (props) => {
    const { changeTableData } = props;
    const importFileRef = useRef(null);

    const parse = () => {
        const fileInput = importFileRef.current;
        if (fileInput && fileInput.files && fileInput.files.length > 0) {
            let file = fileInput.files[0];
            let idx = -1;
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                transformHeader: (header, index) => {
                    if (index < fields.length) {
                        return fields[index];
                    }
                    return header; // Use the original header for any columns beyond your predefined fields.
                },
                complete: (results) => {
                    console.log(results);
                    changeTableData(results.data);
                }
            });
        } else {
            console.log('no file');
        }
    };

    const uploadFileClick = () => {
        const proceed = window.confirm('If you choose to proceed, we will DELETE all the current contacts from the list, and replace them with just the contacts from this csv file. Proceed?');
        if (proceed && window.confirm('Are you sure? These contacts will be DELETED from all lists.')) {
            try {
                DataProvider.deleteMany('contacts', { ids: props.data.contact_ids });
            } catch (err) {
                console.log(err);
            }
            importFileRef.current.click();
        }
    };

    return (
        <div>
            <input
                type="file"
                ref={importFileRef}
                accept='.xlsx, .xls, .csv'
                onChange={parse}
                style={{ display: 'none' }}
            />
            <div>
                <Button style={styles.btn} onClick={uploadFileClick}>
                    <LibraryAddIcon />
                </Button>
            </div>
        </div>
    );
};

export default CsvParseButton;
